/* eslint-disable react/no-danger */
import React from 'react'
import PropTypes from 'prop-types'
import vars from 'li-components/lib/styles'
import HeaderButton from 'li-components/lib/HeaderButton'
import SvgIcon from 'li-components/lib/SvgIcon'

import { List } from '../../components/styled'
import { SecondaryPage, ArticleBody } from './styled'

const Container = SecondaryPage.extend`
  > main {
    padding: 0;
  }
`

const ReleaseNotesList = List.extend`
  > li {
    padding-top: 0;

    &:not(:last-child) {
      border-bottom: 1px solid ${vars.grayLighter};
    }
  }
`

const ReleaseNotes = ({ onClickBackButton, releaseNotes }) => (
  <Container>
    <header onClick={onClickBackButton}>
      <HeaderButton>
        <SvgIcon name="left-2" />
      </HeaderButton>
      <h3>What&apos;s New?</h3>
    </header>
    <main>
      <ReleaseNotesList>
        {releaseNotes.map(note => (
          <li key={note.title + note.date}>
            <ArticleBody>
              <header>
                <h5>{new Date(note.date).toDateString().slice(4)}</h5>
                <h2 dangerouslySetInnerHTML={{ __html: note.title }} />
                {note.image && (
                  <img
                    src={note.image.url}
                    title={note.image.title}
                    alt={note.image.title}
                  />
                )}
              </header>
              <main
                dangerouslySetInnerHTML={{
                  __html: note.description || note.content,
                }}
              />
            </ArticleBody>
          </li>
        ))}
      </ReleaseNotesList>
    </main>
  </Container>
)

ReleaseNotes.propTypes = {
  onClickBackButton: PropTypes.func.isRequired,
  releaseNotes: PropTypes.array.isRequired,
}

export default ReleaseNotes



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/ReleaseNotes.js